/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from 'app/components/Button/Button';
import InputComponent from 'app/components/InputComponent/InputComponent';
import OtpForm from 'app/components/OtpForm/OtpForm';
import {
	getLoginAction,
	setLoginErrorAction,
	setLoginSuccessAction,
} from 'app/redux/actions/LoginAction';
import { RootState } from 'app/redux/store';
import ImagePath from 'app/utilities/imagePath';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import './Login.scss';
import { passwordRegex, phoneFormatRegex } from 'constants/regex';
import {
	generateOtpAction,
	newPasswordRequestAction,
	removeForgotPasswordErrorAction,
} from 'app/redux/actions/ForgotPasswordAction';
import initialForm from 'app/configs/loginForm.config';
import customStyles from '../../../config/modal.config';

const FORM_INDEX = {
	NEW_PASSWORD: 0,
	CONFIRM_NEW_PASSWORD: 1,
};

const loginFormState = {
	LOGIN: 1,
	GENERATE_OTP: 2,
	NEW_PASS: 3,
};

const Login = function init(): React.ReactElement {
	const dispatch = useDispatch();
	const loginState = useSelector((state: RootState) => state.loginReducer);
	const forgotPasswordState = useSelector(
		(state: RootState) => state.forgotPasswordReducer
	);
	const { showOtpModal, generateOtpState, matchOtpState, newPasswordState } =
		forgotPasswordState;
	const { error, message } = loginState;
	const [openModal, setOpenModal] = useState(showOtpModal);
	const [formState, setFormState] = useState(loginFormState.LOGIN);
	const [forgotPassPhoneNum, setForgotPassPhoneNum] = useState('');
	const [isInvalid, setInvalid] = useState(true);
	const [headerText, setHeaderText] = useState(initialForm.login.text);
	const [form, setForm] = useState(initialForm.login.form);
	const [submitButtonText, setSubmitButtonText] = useState(
		initialForm.login.button
	);

	function initLoginForm(): void {
		setFormState(1);
		setHeaderText(initialForm.login.text);
		setForm(initialForm.login.form);
		setSubmitButtonText(initialForm.login.button);
		setInvalid(true);
	}

	function checkError(): void {
		switch (formState) {
			case loginFormState.LOGIN:
				if (error && String(error).includes('tidak terdaftar')) {
					form[0].apiErrorMessage = error;
				} else if (
					error &&
					!String(error).includes('tidak terdaftar')
				) {
					form[1].apiErrorMessage = error;
				} else {
					form[0].apiErrorMessage = '';
					form[1].apiErrorMessage = '';
				}
				break;
			case loginFormState.GENERATE_OTP:
				if (generateOtpState.error) {
					form[0].apiErrorMessage = generateOtpState.error;
				} else {
					form[0].apiErrorMessage = '';
				}
				break;
			case loginFormState.NEW_PASS:
				if (newPasswordState.error) {
					form[0].apiErrorMessage = newPasswordState.error;
				} else {
					form[0].apiErrorMessage = '';
				}
				break;
			default:
				break;
		}

		form.forEach((field) => {
			if (
				field.apiErrorMessage === '' ||
				field.apiErrorMessage === undefined
			) {
				setInvalid(false);
			}
		});

		const updateForm = [...form];
		setForm(updateForm);
	}

	function disableButton(): void {
		let invalid = false;

		if (formState === loginFormState.NEW_PASS) {
			if (
				form[FORM_INDEX.NEW_PASSWORD].value !== '' &&
				!passwordRegex.test(form[FORM_INDEX.NEW_PASSWORD].value)
			) {
				form[FORM_INDEX.NEW_PASSWORD].apiErrorMessage =
					'Kata Sandi harus terdiri dari min 8 karakter, huruf besar, huruf kecil dan angka';
				invalid = true;
			} else {
				form[FORM_INDEX.NEW_PASSWORD].apiErrorMessage = '';
			}
			if (
				form[FORM_INDEX.CONFIRM_NEW_PASSWORD].value !== '' &&
				form[FORM_INDEX.CONFIRM_NEW_PASSWORD].value !==
				form[FORM_INDEX.NEW_PASSWORD].value
			) {
				form[FORM_INDEX.CONFIRM_NEW_PASSWORD].apiErrorMessage =
					'Kata Sandi harus sama dengan Kata Sandi Baru';
				invalid = true;
			} else {
				form[FORM_INDEX.CONFIRM_NEW_PASSWORD].apiErrorMessage = '';
			}
		}
		form.forEach((each) => {
			if (
				each.formType === 'phone' &&
				!phoneFormatRegex.test(each.value)
			) {
				invalid = true;
			}
			if (each.value === '') {
				invalid = true;
			}
			if (each.apiErrorMessage !== '') {
				invalid = true;
			}
		});
		const updateForm = [...form];
		setInvalid(invalid);
		setForm(updateForm);
	}

	function onChangeHandle(event: Record<string, string>): void {
		if (error) {
			dispatch(setLoginErrorAction(''));
		}
		if (
			generateOtpState.error ||
			matchOtpState.error ||
			newPasswordState.error
		) {
			dispatch(removeForgotPasswordErrorAction(''));
		}
		const fieldForm = form.find((field) => field.name === event.name);
		if (fieldForm) {
			fieldForm.value = event.value;

			disableButton();
		}
	}

	useEffect(() => {
		setOpenModal(showOtpModal);
	}, [showOtpModal]);

	useEffect(() => {
		if (message === 'success') {
			window.location.reload();
			form[1].value = '';
			dispatch(setLoginSuccessAction(''));
		}
	}, [message]);

	useEffect(() => {
		checkError();
		disableButton();
	}, [error, generateOtpState.error, newPasswordState.error]);

	useEffect(() => {
		if (newPasswordState.response.message === 'success') {
			initLoginForm();
		}
	}, [newPasswordState.response]);

	function initPhoneChangePasswordForm(): void {
		setFormState(2);
		setHeaderText(initialForm.generateOtp.text);
		setForm(initialForm.generateOtp.form);
		setSubmitButtonText(initialForm.generateOtp.button);
		setInvalid(true);
	}

	function initChangePassForm(): void {
		setFormState(3);
		setHeaderText(initialForm.newPassword.text);
		setForm(initialForm.newPassword.form);
		setSubmitButtonText(initialForm.newPassword.button);
		setInvalid(true);
	}

	useEffect(() => {
		if (matchOtpState.response.isMatch) {
			initChangePassForm();
		}
	}, [matchOtpState.response]);

	const onHandleSubmit = useCallback(
		(event: ChangeEvent<any>): void => {
			event.preventDefault();
			const { phoneNumber, password, newPassword, confirmPassword } =
				event.target.elements;
			let payload;

			switch (formState) {
				case loginFormState.LOGIN:
					payload = {
						phoneNumber: `${phoneNumber.value}`,
						password: password.value,
						type: 'lender',
					};
					dispatch(getLoginAction(payload));
					break;
				case loginFormState.GENERATE_OTP:
					payload = {
						recipient: `${phoneNumber.value}`,
						purpose: 2,
						vendor: 1,
						type: 'lender_institutional',
					};
					setForgotPassPhoneNum(payload.recipient);
					dispatch(generateOtpAction(payload));
					break;
				case loginFormState.NEW_PASS:
					payload = {
						phoneNumber: forgotPassPhoneNum,
						newPassword: newPassword.value,
						confirmPassword: confirmPassword.value,
						type: 'lender_institutional',
						forgotPasswordToken:
							matchOtpState.response.purpose_data
								?.forgot_pasword_token || '',
					};
					dispatch(newPasswordRequestAction(payload));
					break;
				default:
					break;
			}
		},
		[formState, forgotPassPhoneNum, matchOtpState.response]
	);

	return (
		<div className="container">
			<div className="container-left">
				<img
					className="container-image"
					src={ImagePath.verified.src}
					alt={ImagePath.verified.alt}
				/>
			</div>
			<div className="container-right">
				<h2>{headerText.header}</h2>
				<p>{headerText.subHeader}</p>
				<form onSubmit={onHandleSubmit}>
					{form.map((each) => (
						<InputComponent
							key={each.id}
							id={each.id}
							formType={each.formType}
							placeholder={each.placeholder}
							name={each.name}
							apiErrorMessage={each.apiErrorMessage}
							value={each.value}
							onChange={(event) => {
								onChangeHandle(event);
							}}
						/>
					))}
					{formState === loginFormState.LOGIN && (
						<button
							className="forgot-password btn-img"
							type="button"
							onClick={() => initPhoneChangePasswordForm()}
						>
							<h4>Lupa Kata Sandi?</h4>
						</button>
					)}
					<Button
						buttonText={submitButtonText}
						disabled={isInvalid}
					/>
				</form>
				<span className="ojk-afpi">
					Danamas adalah platform peer-to-peer lending yang telah
					berizin dan diawasi oleh
					{' '}
					<b>Otoritas Jasa Keuangan</b>
				</span>
			</div>
			<Modal isOpen={openModal} ariaHideApp={false} style={customStyles}>
				<OtpForm phoneNumber={forgotPassPhoneNum} />
			</Modal>
		</div>
	);
};

export default Login;
